module.exports = __webpack_public_path__ + "static/img/tzgg.f4cb26c4.png";